import React, { useState } from "react";
import "./Tutorial.css";
import { TutorialSlides } from "../../helpers/helpers";
import img1 from "../../assets/images/Rect.png";

const TutorialPage = (props) => {
  const currentSlide = props?.currentSlide

  const Slides = TutorialSlides;


  return (
    <div>
    <div className="carousel-container-t">
       <div className="carousel-slide-t">
        <img src={Slides[currentSlide].image} />
        
       </div>
       
       <h2 className="tuto-head">{Slides[currentSlide].headline}</h2>
       <p className="tuto-p">{Slides[currentSlide].description}</p>
       <div className="carousel-indicators-t">
           {Slides?.map((_, index) => (
             <span
               key={index}
               className={`indicator-t ${index === currentSlide ? "active" : ""}`}
             ></span>
           ))}
         </div>
       </div>
      
     </div>
     
  );
};

export default TutorialPage;
